import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormControlEx } from '../forms/form-control';
import { SelectionItem } from '../select/select.component';

@Component({
    selector: 'app-select-slider',
    templateUrl: './select-slider.component.html',
    styleUrls: ['./select-slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectSliderComponent {
  constructor() {}

  private _control: FormControlEx;
  // Accept AbstractControl for template binding; expose as FormControlEx since
  // select() reads the FormControlEx-specific `isReadonly`.
  @Input() set control(value: AbstractControl) {
    this._control = value as FormControlEx;
  }
  get control(): FormControlEx {
    return this._control;
  }
  @Input() options: SelectionItem[];
  @Input() enabled = true;
  @Input() groupName = 'grp' + Math.random().toString(36).substring(2);

  getSelectorClasses() {
    let selectedValueIndex = -1;
    if (this.control) selectedValueIndex = this.options.findIndex(val => val.value === this.control.value);
    const selectorClass =
      selectedValueIndex < 0 ? 'hidden' : 'selector' + this.options.length.toString() + '_' + selectedValueIndex.toString();
    const itemClass = 'item_' + this.options.length.toString();
    const classes = {};
    classes[selectorClass] = true;
    classes[itemClass] = true;
    classes['disabled'] = !this.enabled;
    return classes;
  }

  getItemClass(option: SelectionItem) {
    return {
      ['item_' + this.options.length]: true,
      pointerCursor: !option.disabled,
      disabled: option.disabled,
    };
  }

  getLabelClass(option: SelectionItem) {
    return {
      pointerCursor: !option.disabled,
      disabled: option.disabled,
    };
  }

  get wrapperClass(): any {
    const classes = {};
    classes['cwrapper'] = true;
    classes['disabled'] = !this.enabled;
    return classes;
  }

  select(value: string) {
    const selectedItem = this.options.find(option => option.value === value);
    if (!this.control || this.control.isReadonly || !this.enabled || selectedItem?.disabled) return false;
    this.control.setValue(value);
  }
}
